/* import __COLOCATED_TEMPLATE__ from './sdt-activated-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();